<div *ngIf="modalArguments" xmlns="http://www.w3.org/1999/html" data-test-id="modal-default" class="modal-window">
  <div class="modal-header">
    <h4 class="modal-title" data-test-id="modal-title">
      {{ modalArguments.title }}
    </h4>
    <button
      type="button"
      class="unstyled-button"
      aria-label="Close"
      data-test-id="modal-btn-dismiss"
      (click)="onDismiss()"
    >
      <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
    </button>
  </div>
  <div class="modal-body" data-test-id="wrap-admin-invite">
    <label class="form-label dialog-label">{{ 'SIGN_UP_FORM_EMAIL_LABEL' | translate }}</label>
    <form *ngIf="form" class="" [formGroup]="form">
      <input
        class="form-control"
        [ngClass]="{ 'is-invalid': isEmailValid() }"
        type="email"
        formControlName="email"
        id="email"
        data-test-id="form-email"
        placeholder="{{ modalArguments.description }}"
      />
      <small class="invalid-feedback" data-test-id="error-description">
        {{ getErrorDescriptionId('email') | translate }}
      </small>
      <small class="text-muted">{{ 'SEND_SIGNUP_INVITATION_EMAIL_INPUT_TIP' | translate }}</small>
    </form>
  </div>
  <div class="modal-footer" data-test-id="modal-footer">
    <button
      *ngFor="let button of modalArguments.buttons; index as i"
      [attr.type]="button.type || 'button'"
      class="btn"
      [ngClass]="button.class"
      (click)="actionsHandler(button.action)"
      [attr.data-test-id]="'modal-btn-' + button.action"
      [disabled]="button.action === confirmActionButton && !isFormValid"
    >
      {{ button.text | translate }}
    </button>
  </div>
</div>
